import { FormattedMessage } from 'react-intl'
import Text from '../../../shared/Text'
import Tabs from './Tabs'
import { CustomPricePointTab } from './CustomPricePointTab'
import { CalculatePricePointTab } from './CalculatePricePointTab'
import { PrequalTab } from './PrequalTab'
import PromptPrequal from './PromptPrequal'
import { useDispatch, useSelector } from 'react-redux'
import { persistAffordability, toggleAffordabilityModal } from '../../../../actions/affordability'
import {
  selectShowPrequalPrompt,
  selectPrequalRequested,
  selectShowModal
} from '../../../../store/selectors/affordability'
import styles from './AffordabilityModal.module.scss'
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@homebotapp/hb-react-component-catalog'

const ModalTitle = ({ prequal, requested }) => (
  <Box my={4}>
    {!prequal && (
      <Text element='div' size='xl' variant='neutralCool' variantCount='900'>
        <FormattedMessage id='Affordability.modal.mainTitle' defaultMessage='Tune your budget' />
      </Text>
    )}

    {prequal && !requested && (
      <Text variant='neutralCool' variantCount='900'>
        <FormattedMessage id='Affordability.modal.altTitle' defaultMessage='Want a smart budget?' />
      </Text>
    )}
  </Box>
)

interface ModalSubTitleProps {
  hide: boolean
}

const ModalSubTitle = ({ hide }: ModalSubTitleProps) => {
  if (hide) {
    return null
  }
  return (
    <FormattedMessage
      id='Affordability.modal.subTitle'
      defaultMessage='An accurate budget makes your market exploration smarter.'
    />
  )
}

export const AffordabilityModal = () => {
  const dispatch = useDispatch()
  const showPrompt = useSelector(selectShowPrequalPrompt)
  const prequalRequested = useSelector(selectPrequalRequested)
  const showAffordabilityModal = useSelector(selectShowModal)

  const toggleModal = () => dispatch(toggleAffordabilityModal())

  const onSubmit = event => {
    event.preventDefault()
    dispatch(persistAffordability())
  }

  return (
    <Modal isOpen={showAffordabilityModal} onClose={toggleModal}>
      <ModalOverlay />
      <ModalContent textAlign='center' overflow='hidden'>
        <ModalCloseButton />
        <ModalTitle prequal={showPrompt} requested={prequalRequested} />
        <ModalSubTitle hide={showPrompt} />
        <Tabs className={styles.tabs} hide={showPrompt} />
        <ModalBody py={6} bg='neutral.100'>
          {showPrompt ? (
            <PromptPrequal />
          ) : (
            <form onSubmit={onSubmit}>
              <PrequalTab />
              <CalculatePricePointTab />
              <CustomPricePointTab />
            </form>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
